import { App } from "antd"
import type { ArgsProps } from "antd/lib/notification"
import type React from "react"

import {
  type NotificationType,
  notificationOptions
} from "../constants/notification.config"

export const useNotifications = () => {
  // `App.useApp()` rather than antd's static `notification`: the static API
  // renders its own root outside the ConfigProvider tree and so never picks up
  // the theme's font or tokens.
  const { notification } = App.useApp()

  const types = (Object.keys(notificationOptions) as NotificationType[]).reduce(
    (acc, key) => {
      acc[key] = (config: ArgsProps) =>
        notification[key]({
          ...config,
          ...notificationOptions[key]
        })
      return acc
    },
    {} as Record<NotificationType, (config: ArgsProps) => void>
  )

  return {
    ...types,
    //
    open: notification.open,
    destroy: (key?: React.Key) => notification.destroy(key)
  }
}
